import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("IdentityAccess/api/PermissionsQuery").then(r => {
        commit("setList", r.data.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("IdentityAccess/api/Permissions", model).then(() => {});
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "IdentityAccess/api/Permissions",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    update({ commit, dispatch }, model) {
      return ajax.put("IdentityAccess/api/Permissions", model).then(() => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
